import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pr-clients',
  templateUrl: './pr-clients.component.html',
  styleUrls: ['./pr-clients.component.scss']
})
export class PrClientsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
